// import { useGtag } from "vue-gtag-next";

const UserStore = {
    state: {
        userInfo: {},
        lang: "ko",
        questsStatus: {
            count: 0,
            step: "",
            done: {
                step1: false,
                step2: false,
                step3: false
            },
            symbol: null
        },
        quality: "high",
        sound: false,
        locate: "global",
        isMulti: false
    },
    mutations: {
        setUserInfo(state, userInfo) {
            state.userInfo = userInfo;
        },
        setUserLang(state, lang) {
            state.lang = lang;
        },
        setQuestsStatus(state, status) {
            state.questsStatus = status;
        },
        setQuality(state, quality) {
            state.quality = quality;
        },
        setSound(state, sound) {
            state.sound = sound;
        },
        setLocate(state, locate) {
            state.locate = locate;
        },
        setUserCharacterColor(state, color) {
            if(state.userInfo) {
                state.userInfo.avatarColor = color;
            }
        },
        setIsMulti(state, isMulti) {
            state.isMulti = isMulti;
        }
    },
    getters: {
        getUserInfo(state) {
            return state.userInfo;
        },
        getUserLang(state) {
            return state.lang;
        },
        getQuestsStatus(state) {
            return state.questsStatus;
        },
        getQuality(state) {
            return state.quality;
        },
        getSound(state) {
            return state.sound;
        },
        getLocate(state) {
            return state.locate;
        },
        getIsMulti(state) {
            return state.isMulti;
        }
    },
    actions: {
        async setUserInfo({commit}, params) {
            const userId = String(new Date().getTime() + Math.random());
            const nickname = params.nickname;
            const avatarType = params.avatarType;
            const avatarColor = params.avatarColor;

            commit("setUserInfo", {
                id: userId,
                _id: userId,
                nickname: nickname,
                avatarType: avatarType,
                avatarColor: avatarColor
            });
        },
        setLang({commit}, params) {
            commit("setUserLang", params.lang);
        },
        setQuality({commit}, params) {
            commit("setQuality", params.quality);
        },
        setSound({commit}, params) {
            commit("setSound", params.sound);
        },
        setLocate({commit}, params) {
            commit("setLocate", params.locate);
        },
        setUserCharacterColor({commit}, params) {
            commit("setUserCharacterColor", params.color);
        },
        setUserIsMulti({commit}, params) {
            commit("setIsMulti", params.isMulti);
        },
    }
}

export default UserStore;